<template>
    <div>
      <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.personal.title') }}</h3>
      <v-card class="mt-2" elevation="0">
        <v-form>
            <v-switch
                    @change="$store.dispatch('users/changeCurrentUserTheme', $vuetify.theme.dark ? 'dark' : 'light').then((res)=>{$vuetify.theme.dark = res==='dark' })"
                    v-model="$vuetify.theme.dark"
                    label="Theme Dark"
            ></v-switch>
            <v-switch
                    color="primary"
                    v-model="changePassword"
                    :label="$t('common.change_password')"
            ></v-switch>
            <v-text-field
                    v-model="currentUser.current_password"
                    v-if="changePassword"
                    :label="$t('common.current_password')"
                    prepend-icon="fa-lock"
                    required
                    :error-messages="currentPasswordErrors"
                    @input="$v.currentUser.current_password.$touch()"
                    @blur="$v.currentUser.current_password.$touch()"
                    type="password"
                    @keyup.enter="submit"
                    autocomplete="off"
            ></v-text-field>

            <v-text-field
                    v-model="currentUser.password"
                    v-if="changePassword"
                    :label="$t('common.new_password')"
                    :prepend-icon="(currentUser.password===currentUser.password_confirmation)?'fa-lock':'fa-lock-open'"
                    required
                    :error-messages="passwordErrors"
                    @input="$v.currentUser.password.$touch()"
                    @blur="$v.currentUser.password.$touch()"
                    type="password"
                    @keyup.enter="submit"
                    autocomplete="off"
            ></v-text-field>
            <v-text-field
                    v-if="changePassword"
                    v-model="currentUser.password_confirmation"
                    :label="$t('common.password_confirmation')"
                    :prepend-icon="(currentUser.password===currentUser.password_confirmation)?'fa-lock':'fa-lock-open'"
                    required
                    :error-messages="passwordConfirmErrors"
                    @input="$v.currentUser.password_confirmation.$touch()"
                    @blur="$v.currentUser.password_confirmation.$touch()"
                    type="password"
                    @keyup.enter="submit"
                    autocomplete="off"
            ></v-text-field>

            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-btn
                    :disabled="savingInProgress"
                    :loading="savingInProgress"
                    v-if="changePassword"
                    class="mt-5"
                    elevation="0"
                    color="primary"
                    @click="submit"
                    @keyup.enter="submit"
            >
                {{ $t('common.save') }}
            </v-btn>
        </v-form>
      </v-card>
    </div>
</template>

<script>
    import { required, email, sameAs, minLength,  } from "vuelidate/lib/validators";
    import { mapFields } from 'vuex-map-fields';
    import router from "../../router";
    export default {
        data: () => ({
            changePassword: false,
            currentUser: {
                current_password:null,
                password_confirmation:null,
                password:null
            }
        }),
        created(){

        },
        validations(){
            let res = {
                currentUser: {}
            };
            if(this.changePassword){
                res.currentUser.current_password = {required};
                res.currentUser.password = {required, minLength: minLength(6)};
                res.currentUser.password_confirmation = {sameAsPassword: sameAs('password')};
            }
            return res;
        },
        computed: {
            ...mapFields('users', ['savingInProgress']),
            currentPasswordErrors() {
                const errors = [];
                if (!this.$v.currentUser.current_password) return errors;
                if (!this.$v.currentUser.current_password.$dirty) return errors;
                !this.$v.currentUser.current_password.required && errors.push(this.$t('form.validationErrors.field_is_required'));
                return errors;
            },
            passwordErrors() {
                const errors = [];
                if (!this.$v.currentUser.password) return errors;
                if (!this.$v.currentUser.password.$dirty) return errors;
                !this.$v.currentUser.password.required && errors.push(this.$t('form.validationErrors.field_is_required'));
                !this.$v.currentUser.password.minLength && errors.push(this.$t('form.validationErrors.minLength', [6]));
                return errors;
            },
            passwordConfirmErrors() {
                const errors = [];
                if(!this.$v.currentUser.password_confirmation) return errors;
                if (!this.$v.currentUser.password_confirmation.$dirty) return errors;
                !this.$v.currentUser.password_confirmation.sameAsPassword && errors.push(this.$t('form.validationErrors.password_confirmation_doesnt_match'));
                return errors;
            },

        },
        watch: {

        },
        methods: {
            submit(){
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.$store.dispatch('users/changeCurrentUserPassword', this.currentUser).then((res)=>{
                    if(res){
                        this.changePassword = false;
                        this.currentUser = {
                            current_password:null,
                            password_confirmation:null,
                            password:null
                        };
                        this.$v.$reset();
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>